export enum TipoSecaoHome {
    Banners = 1,
    DiarioOficial = 2,
    Noticias = 3,
    TextoLivre = 4,
    AcessoRapido = 5,
    CardDestaque = 6,
    Videos = 7,
}

export enum TipoSecaoPaginaCustomizada {
    TextoLivre = 1,
    ListaItens = 2,
    GaleriaImagens = 3,
    Faq = 4,
    ConteudoMisto = 5,
    VideoEmbed = 6,
    ListaLinks = 7,
    Documentos = 8,
}

export const TIPO_SECAO_HOME_LABEL: Record<TipoSecaoHome, string> = {
    [TipoSecaoHome.Banners]: 'Banners',
    [TipoSecaoHome.DiarioOficial]: 'Diário Oficial',
    [TipoSecaoHome.Noticias]: 'Notícias',
    [TipoSecaoHome.TextoLivre]: 'Texto Livre',
    [TipoSecaoHome.AcessoRapido]: 'Acesso Rápido',
    [TipoSecaoHome.CardDestaque]: 'Card Destaque',
    [TipoSecaoHome.Videos]: 'Vídeos',
};

export const TIPO_SECAO_PAGINA_LABEL: Record<TipoSecaoPaginaCustomizada, string> = {
    [TipoSecaoPaginaCustomizada.TextoLivre]: 'Texto Livre',
    [TipoSecaoPaginaCustomizada.ListaItens]: 'Lista de Itens',
    [TipoSecaoPaginaCustomizada.GaleriaImagens]: 'Galeria de Imagens',
    [TipoSecaoPaginaCustomizada.Faq]: 'FAQ',
    [TipoSecaoPaginaCustomizada.ConteudoMisto]: 'Conteúdo Misto',
    [TipoSecaoPaginaCustomizada.VideoEmbed]: 'Vídeo',
    [TipoSecaoPaginaCustomizada.ListaLinks]: 'Lista de Links',
    [TipoSecaoPaginaCustomizada.Documentos]: 'Documentos',
};

// Seções criadas automaticamente pela API: não podem ser adicionadas nem excluídas, apenas ocultadas
export const HOME_FIXED_SECTION_TYPES: TipoSecaoHome[] = [
    TipoSecaoHome.DiarioOficial,
    TipoSecaoHome.Noticias,
];

// Banners é banner de corpo: adicionado e posicionado entre os informativos (o carrossel do topo é o da tela de Banners)
export const HOME_ADDABLE_SECTION_TYPES: TipoSecaoHome[] = [
    TipoSecaoHome.TextoLivre,
    TipoSecaoHome.AcessoRapido,
    TipoSecaoHome.CardDestaque,
    TipoSecaoHome.Videos,
    TipoSecaoHome.Banners,
];

export const HOME_SECTION_TYPES_WITH_ITEMS: TipoSecaoHome[] = [
    TipoSecaoHome.Banners,
    TipoSecaoHome.AcessoRapido,
    TipoSecaoHome.CardDestaque,
    TipoSecaoHome.Videos,
];

export const CUSTOM_PAGE_SECTION_TYPES_WITH_ITEMS: TipoSecaoPaginaCustomizada[] = [
    TipoSecaoPaginaCustomizada.ListaItens,
    TipoSecaoPaginaCustomizada.GaleriaImagens,
    TipoSecaoPaginaCustomizada.Faq,
    TipoSecaoPaginaCustomizada.ConteudoMisto,
    TipoSecaoPaginaCustomizada.ListaLinks,
    TipoSecaoPaginaCustomizada.Documentos,
];

export const NEWS_QUANTITY_MIN = 1;
export const NEWS_QUANTITY_MAX = 20;

// Chaves de ícone do Acesso Rápido, gravadas como texto e interpretadas pelo portal público
export const ACESSO_RAPIDO_ICONS: { value: string; label: string }[] = [
    { value: 'description', label: 'Documento' },
    { value: 'gavel', label: 'Legislação' },
    { value: 'account_balance', label: 'Instituição' },
    { value: 'payments', label: 'Finanças' },
    { value: 'receipt_long', label: 'Nota fiscal' },
    { value: 'shopping_cart', label: 'Compras e Licitações' },
    { value: 'work', label: 'Concursos' },
    { value: 'groups', label: 'Servidores' },
    { value: 'support_agent', label: 'Atendimento' },
    { value: 'campaign', label: 'Ouvidoria' },
    { value: 'visibility', label: 'Transparência' },
    { value: 'event', label: 'Agenda' },
    { value: 'newspaper', label: 'Notícias' },
    { value: 'menu_book', label: 'Diário Oficial' },
    { value: 'health_and_safety', label: 'Saúde' },
    { value: 'school', label: 'Educação' },
    { value: 'phone', label: 'Contato' },
    { value: 'place', label: 'Localização' },
    { value: 'link', label: 'Link' },
];

export enum SituacaoAuditoria {
    Entregue = 1,
    Sobrestado = 2,
    Julgado = 3,
}

export enum OrgaoFiscalizador {
    TCM = 1,
    TCE = 2,
    TCU = 3,
    CGU = 4,
}

export enum TipoBanner {
    Integrado = 1,
    Popup = 2,
    Ambos = 3,
}

export enum TipoProjetoGovernamental {
    Projeto = 1,
    Atividade = 2,
    Acao = 3,
    Programas = 4,
}

export const SITUACAO_AUDITORIA_LABEL: Record<SituacaoAuditoria, string> = {
    [SituacaoAuditoria.Entregue]: 'Entregue',
    [SituacaoAuditoria.Sobrestado]: 'Sobrestado',
    [SituacaoAuditoria.Julgado]: 'Julgado',
};

export const ORGAO_FISCALIZADOR_LABEL: Record<OrgaoFiscalizador, string> = {
    [OrgaoFiscalizador.TCM]: 'TCM',
    [OrgaoFiscalizador.TCE]: 'TCE',
    [OrgaoFiscalizador.TCU]: 'TCU',
    [OrgaoFiscalizador.CGU]: 'CGU',
};

export const TIPO_BANNER_LABEL: Record<TipoBanner, string> = {
    [TipoBanner.Integrado]: 'Carrossel',
    [TipoBanner.Popup]: 'Popup',
    [TipoBanner.Ambos]: 'Carrossel e popup',
};

export const TIPO_PROJETO_GOVERNAMENTAL_LABEL: Record<TipoProjetoGovernamental, string> = {
    [TipoProjetoGovernamental.Projeto]: 'Projeto',
    [TipoProjetoGovernamental.Atividade]: 'Atividade',
    [TipoProjetoGovernamental.Acao]: 'Ação',
    [TipoProjetoGovernamental.Programas]: 'Programa',
};

export enum StatusLicitacao {
    EmAndamento = 1,
    Anulada = 2,
    Cancelada = 3,
    Deserta = 4,
    Encerrada = 5,
    Frustrada = 6,
    Homologada = 7,
    Suspensa = 8,
    Revogada = 9,
}

export const STATUS_LICITACAO_LABEL: Record<StatusLicitacao, string> = {
    [StatusLicitacao.EmAndamento]: 'Em andamento',
    [StatusLicitacao.Anulada]: 'Anulada',
    [StatusLicitacao.Cancelada]: 'Cancelada',
    [StatusLicitacao.Deserta]: 'Deserta',
    [StatusLicitacao.Encerrada]: 'Encerrada',
    [StatusLicitacao.Frustrada]: 'Frustrada',
    [StatusLicitacao.Homologada]: 'Homologada',
    [StatusLicitacao.Suspensa]: 'Suspensa',
    [StatusLicitacao.Revogada]: 'Revogada',
};

// Opções para <Select> a partir dos mapas de rótulo (chaves numéricas do enum)
export function enumOptions<T extends number>(labels: Record<T, string>): { value: T; label: string }[] {
    return (Object.keys(labels) as unknown as T[]).map((key) => ({ value: Number(key) as T, label: labels[key] }));
}
